import { useState, useEffect } from 'react';
import { useDataFetch } from '../../../hooks/use-data-fetch';
import { Product } from '../../../store/cart-store';


export const useProducts = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(6);
  
  const { getData } = useDataFetch();
  
  // Fetch products
  const { data: productsData, isLoading } = getData(
    ['products'],
    '/product/byUser'
  );
  
  // Update products state when data changes
  useEffect(() => {
    if (productsData?.data?.products) {
      setProducts(productsData.data.products);
    }
  }, [productsData]);
  
  // Filter and search products
  const filteredProducts = products.filter((product) => {
    const matchesSearch =
      searchQuery === '' ||
      product.title.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory =
      selectedCategory === '' ||
      product.category.id === selectedCategory;

    return matchesSearch && matchesCategory;
  });

  const totalProducts = filteredProducts.length;
  const totalPages = Math.ceil(totalProducts / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentProducts = filteredProducts.slice(startIndex, endIndex);

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1); // Reset to page 1 on search
  };
  
  const handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedCategory(e.target.value);
    setCurrentPage(1); // Reset to page 1 on category change
  };

  return {
    products,
    currentProducts,
    isLoading,
    searchQuery,
    selectedCategory,
    currentPage,
    totalPages,
    totalProducts,
    startIndex,
    endIndex,
    handlePageChange,
    handleSearchChange,
    handleCategoryChange
  };
};
